<template>
  <div class="el-form-item" :class="{ 'is-required': required }">
    <label class="el-form-item__label">{{ label }}</label>
    <div class="el-form-item__content">
      <slot
        ><p class="text-gray-950 text-base lg:text-lg break-all">{{ value }}</p></slot
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: () => '' },
    value: { default: () => '' },
    required: { type: Boolean, default: () => false },
  },
}
</script>

<style></style>
